// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';

export default styled<any, Theme>('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0.5rem;
  min-height: 6.25rem;

  ${media.sm(css`
    height: 9.375rem;
  `)}
`;
